import React from 'react';
import './navdrawer.css';
import { Link } from 'gatsby';
class NavDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };
    this.toggleOpen = this.toggleOpen.bind(this);
  }

  toggleOpen = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };
  render() {
    const { children } = this.props;
    const { isOpen } = this.state;
    return (
      <>
        <div className='drawer'>
          <div className={`nav-container ${isOpen ? 'open' : ''}`}>
            <div className={'links'}>
              <div>
                <h3>Devfest Bangalore</h3>
              </div>
              <div>
                <Link to={'/'} activeClassName={'nav-active'}>
                  Home
                </Link>
              </div>
              <div>
                <Link to={'/partners'} activeClassName={'nav-active'}>
                  Partners
                </Link>
              </div>
              <div>
                <Link to={'/day1'} activeClassName={'nav-active'}>
                  Day 1
                </Link>
              </div>
              <div>
                <Link to={'/day2'} activeClassName={'nav-active'}>
                  Day 2
                </Link>
              </div>
              <div>
                <Link to={'/organizers'} activeClassName={'nav-active'}>
                  Organizers
                </Link>
              </div>
            </div>
          </div>
          <div className='drawer-opener' onClick={this.toggleOpen}>
            <a className='whopper' href='#'>
              <div className='menu'>
                <div className={`bar one ${isOpen ? 'one-ani' : ''}`}></div>
                <div className={`bar two ${isOpen ? 'two-ani' : ''}`}></div>
              </div>
            </a>
          </div>
          <div
            onClick={() => {
              isOpen && this.toggleOpen();
            }}
            className={`drawer-container ${isOpen ? 'open' : ''}`}>
            {children}
          </div>
        </div>
      </>
    );
  }
}

export default NavDrawer;
